export default __webpack_public_path__ + "static/media/DL_Jewelry_Logo.558d8d35.png";